import { Connection } from '@/assets/icons/ats';
import { Mail02 } from '@kula-ai/icons/outline/Mail02';
import { LuCalendarPlus, LuLinkedin } from 'react-icons/lu';

export const conversationConstants = {
  email: {
    id: 'email',
    value: 'an email',
    bg: '#DCCCFF',
    icon: Mail02,
    color: '#7D54D8',
  },
  li_inmail: {
    id: 'li_inmail',
    value: 'a linkedin inmail',
    bg: '#E0EAFF',
    icon: LuLinkedin,
    color: '#444CE7',
  },
  li_connection: {
    id: 'li_connection',
    value: 'a linkedin connection request',
    bg: '#FEE1B6',
    icon: Connection,
    color: '#DC8400',
  },
  calendar_invite: {
    id: 'calendar_invite',
    value: 'a calendar invite',
    bg: '#EDF6EA',
    icon: LuCalendarPlus,
    color: '#5FBB3F',
  },
  self_schedule: {
    id: 'self_schedule',
    value: 'a self schedule email',
    bg: '#EDF6EA',
    icon: LuCalendarPlus,
    color: '#5FBB3F',
  },
  kula_platform: {
    id: 'kula_platform',
    value: 'a message',
    bg: '#EDF6EA',
    icon: LuCalendarPlus,
    color: '#5FBB3F',
  },
};
